var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    viewBox: "0 0 27 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9721 39.4989C8.7171 39.4989 4.81518 37.4216 2.26676 33.7999C-2.75855 26.6578 2.51539 14.8623 2.74208 14.3634C2.9258 13.9592 3.52612 14.0314 3.60747 14.4697C3.76126 15.3013 4.29256 17.2777 5.15293 18.2804C5.10151 15.2923 5.50964 6.27298 11.837 0.616507C12.0555 0.421354 12.5434 0.427524 12.6046 0.988989C12.7694 2.50817 13.5182 7.57255 16.2396 8.95371C16.5072 9.0899 19.041 12.2857 19.4825 15.2514C19.9265 14.6744 20.5412 13.4297 20.8221 10.818C20.8639 10.429 21.3458 10.27 21.6118 10.5559C21.708 10.6594 31.1506 21.0468 24.5663 32.557C22.0801 36.9043 17.7461 39.4989 12.9721 39.4989Z",
    fill: "#FFA725"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6808 36.2818C16.2031 36.2818 18.5162 35.0506 20.0269 32.9037C23.0058 28.6697 19.8795 21.6776 19.7451 21.3819C19.6361 21.1422 19.2803 21.1851 19.2321 21.445C19.1409 21.9379 18.826 23.1095 18.316 23.7038C18.3464 21.9324 18.1046 16.586 14.3538 13.2328C14.2242 13.1171 13.9351 13.1208 13.8988 13.4535C13.801 14.3541 13.3572 17.3561 11.7439 18.1749C11.5853 18.2556 10.0832 20.1502 9.82136 21.9082C9.5581 21.5661 9.19362 20.8282 9.02726 19.28C9.00235 19.0494 8.71671 18.955 8.55926 19.1246C8.50213 19.1861 2.90484 25.3437 6.80791 32.1667C8.28184 34.7437 10.8507 36.2818 13.6808 36.2818Z",
    fill: "#FF871E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85986 33.6276C9.45699 33.6276 9.24767 33.1359 9.53674 32.8473L16.8513 25.5325C17.2775 25.1063 17.9233 25.7539 17.498 26.1789L10.1832 33.4937C10.0939 33.5831 9.97709 33.6276 9.85986 33.6276Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1965 29.1139C8.66976 29.1139 8.66816 25.27 11.196 25.27C13.7241 25.27 13.7229 29.1139 11.1965 29.1139ZM11.1965 26.1834C10.3041 26.1834 9.84959 27.2698 10.4835 27.9041C11.4056 28.8264 12.8596 27.43 11.9092 26.4789C11.7189 26.2881 11.4659 26.1834 11.1965 26.1834Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.839 33.7557C13.3121 33.7557 13.3109 29.9121 15.839 29.9121C18.3668 29.9121 18.3666 33.7557 15.839 33.7557ZM15.839 30.8254C14.9464 30.8254 14.4923 31.9118 15.1262 32.5462C16.0481 33.4687 17.5021 32.0715 16.552 31.1209C16.3616 30.9301 16.1082 30.8254 15.839 30.8254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/SVG.a1e27c144e121e491fa7d6aa8151da6a.svg";
export { ForwardRef as ReactComponent };